import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent }   from './login/login.component';
import {ValidateAccountComponent} from "./validate-account/validate-account.component";
import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";
import {CguComponent} from "./cgu/cgu.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'administration',
    pathMatch: 'full'
  },
  {
    path: 'connexion',
    component: LoginComponent
  },
  {
    path: 'cgu',
    component: CguComponent
  },
  {
    path: 'validation-compte/:email/:accept',
    component: ValidateAccountComponent
  },
  {
    path: 'nouveau-mot-de-passe/:email/:reset',
    component: ForgotPasswordComponent
  }

];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts